import styled from "styled-components/macro";
import { theme } from "ui/theme";
import { transition } from "helpers/css";

const cardHoverBoxShadow = `0 0.25rem 0 ${theme.ColorSneaker300}`;

const cardHoverTransitionStyles = `
  // The default transition timing is intentionaly different than the hover/focus
  // one so it feels like it reacts less enthusiastically.
  ${transition("0.4s box-shadow ease-in-out, 0.4s transform ease-in-out")}

  // Fractional pixel aligned text appears to shift left and right when being
  // animated using translateY, but according to a variety of google research,
  // using translate3d instead fixes that problem. I don't quite understand why,
  // but it definitely works.
  transform: translate3d(0, 0, 0);

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    transform: translate3d(0, -2px, 0);
    // The hover/focus transition duration is shorter so that the cards react faster
    // to hover start than to hover end.
    ${transition("0.2s box-shadow ease-out, 0.2s transform ease-out")}
  }
  &:active {
    transform: translate3d(0, 4px, 0);
  }
`;

const staticPositionStyles = `
  box-shadow: none;
  transform: translate3d(0, 2px, 0);
`;

interface CardProps {
  $noHoverState?: boolean;
}

const Card = styled.div<CardProps>`
  ${cardHoverTransitionStyles}

  border: 1px solid ${theme.ColorSpace200};
  border-radius: 1rem;
  box-shadow: 0 0.125rem 0 ${theme.ColorSneaker300};
  overflow: hidden;
  vertical-align: top;

  // Card shifts up on focus or hover state.
  &:hover,
  &:focus {
    box-shadow: ${cardHoverBoxShadow};
  }

  // Card shifts back down on active state.
  &:active {
    ${staticPositionStyles}
  }

  ${({ $noHoverState }) =>
    $noHoverState &&
    `
    ${staticPositionStyles}

    &:hover,
    &:focus {
      ${staticPositionStyles}
    }
  `}
`;

export default Card;
